<template>
    <div class="home">
        <!-- <img src="../assets/logo.png" class="logo-img" /> -->
        <cube-button @click="sayHello()">开始</cube-button>
        <cube-button :light=true @click="say()">说点什么</cube-button>
        <router-link to="/">Home</router-link> |
        <router-link to="/about">About</router-link> |
        <router-link to="/notFoundPage">404</router-link>
        <cube-toolbar :actions="actions" @click="clickHandler"></cube-toolbar>
    </div><!-- home结束 -->
</template>
<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
    name: 'home',
    components: {
        // HelloWorld
    },
    data() {
        return {
            actions: [
                {
                    text: '首页',
                    action: 'home'
                },
                {
                    text: '关于',
                    action: 'about'
                },
                {
                    text: '404',
                    action: 'notFoundPage'
                }
              ]
        }
    },
    methods: {
        sayHello() {
            this.toast = this.$createToast({
                txt: '你好',
                type: 'txt'
            }).show();
        },
        say() {
            if (this.dialog) this.dialog.promptValue = '';
            this.dialog = this.$createDialog({
                type: 'prompt',
                title: '名字',
                confirmBtn: '打招呼',
                prompt: {
                    value: '',
                    placeholder: '请输入你的名字'
                },
                onConfirm: (e, promptValue) => {
                    if (!promptValue) {
                        promptValue = '某某某';
                    }
                    this.$createToast({
                        type: '',
                        txt: '你好呀，' + promptValue
                    }).show();   
                }
            }).show();
        },
        clickHandler(item) {
            if (item.action) {
                this.$router.push({ name: item.action });
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.home {
    padding: 15px;
    img { width: 160px; }
    button, .input-style { margin-bottom: 30px; }
    .logo-img {
        display: block;
        margin: 22px auto;
    }
}
</style>
